import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import RouteHistory from "go-core/utils/routeHistory";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { ClientApi } from "../../../../../../../../../../services/Api/Organization/types";
import ClientForm from "../../components/ClientForm";

interface MatchParams {
	clientId: string;
}

const OrganizationClientsIndexEditPage = (): JSX.Element => {
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>();
	const [client, setClient] = useState<ClientApi>();
	const { t } = useTranslation();
	const history = useHistory();
	const organization = useSelector(selectOrganization);
	const { addFlash } = useFlash();
	const { clientId } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetch();
	}, []);

	useEffect(() => {
		handleChangeTabTitle(
			`${client?.name || client?.tax_id_no || client?.contact_phone_number || client?.contact_email} | ${t(
				"modules.client.header.title"
			)}`
		);
	}, [client?.name, client?.tax_id_no, client?.contact_phone_number, client?.contact_email]);

	const fetch = async () => {
		try {
			const cfParams: Record<string, string> = {
				f: btoa(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}resource_type|e=CLIENT`),
				include: "options,constraints",
			};
			const clientParams: Record<string, any> = { include: "client_group,custom_fields" };
			const promises = Promise.all([
				apiOrganization.getClient(Number(clientId), clientParams),
				apiOrganization.getCustomFields(cfParams),
			]);
			const [fetchedClient, customFields] = await promises;

			setCustomFieldsConfig(customFields);
			setClient(fetchedClient);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!client || !customFieldsConfig) {
		return <LoadingContainer />;
	}

	const goBack = () => RouteHistory.goBack(history, `/${organization.id}/clients/${client.id}`);

	return (
		<>
			<Header title={`${t("modules.client.header.title")} "${client.name}"`} back={goBack} />
			<ClientForm client={client} setClient={setClient} customFieldsConfig={customFieldsConfig} />
		</>
	);
};
export default OrganizationClientsIndexEditPage;
